<template>
  <v-card>
    <v-textarea
      solo
      flat
      auto-grow
      clearable
      label="Suggest an answer"
      prepend-inner-icon="add"
      v-model="newAlternative"
    ></v-textarea>
    <v-card-actions>
      <v-spacer></v-spacer>
      <v-btn flat color="primary" @click="addAlternative">Submit</v-btn>
    </v-card-actions>
  </v-card>
</template>

<script>
import * as cardFuncs from "../functions/card-funcs";
import * as userFuncs from "../functions/user-funcs";

export default {
  props: ["card"],
  data: () => ({
    newAlternative: ""
  }),
  computed: {
    user() {
      return this.$store.getters.currentUser;
    }
  },
  methods: {
    addAlternative: function() {
      if (
        this.newAlternative === "" ||
        this.newAlternative.substring(0, 1) === "\n"
      ) {
        return;
      }

      cardFuncs.addNewAlternativeToCard(
        this.card,
        this.newAlternative,
        userFuncs.getUserRef(this.user.uid)
      );
      this.newAlternative = "";
    }
  }
};
</script>
